import { render } from "./Formbasicinput.vue?vue&type=template&id=29dffa41"
import script from "./Formbasicinput.vue?vue&type=script&lang=js"
export * from "./Formbasicinput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__